import React, { Component } from "react";
import * as LINKS from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div class="mt-5 p-6 container">
        <div class="columns">
          <div class="column is-flex-grow-5">
            <div class="ant-card ant-card-bordered">
              <div class="ant-card-body">
                <div class="flex items-center"><input type="text" class="input mr-2" placeholder="Search by LP token address or token address..." /></div>
                <ul class="PinkLockLiquidityPage_filter__1hTbu">
                  <li class="PinkLockLiquidityPage_active__3TPxj">All</li>
                  <li class="">My lock</li>
                </ul>
                <div class="ant-spin-nested-loading">
                  <div class="ant-spin-container">
                    <ul class="ant-list-items">
                      <li class="ant-list-item">
                        <div class="PinkLockList_tvl__2g8Av"><strong>
                          <p>Liquidity token</p>
                        </strong></div>
                        <div class="PinkLockList_tvl__2g8Av"><strong>Amount</strong>
                        </div>
                        <div style={{ opacity: "0" }}>View</div>
                      </li>
                    </ul>
                    <div class="ant-list ant-list-split">
                      <div class="ant-spin-nested-loading">
                        <div class="ant-spin-container">
                          <ul class="ant-list-items">
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      Portugal/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      FPF/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  223,606.7977 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      Iris Chain/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      wIRIS/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  9,246.6210 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://photos.pinksale.finance/file/pinksale-logo-upload/1668612075811-fb7ee040cd523b5490e41a8e385dfad7.jpg&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      PI Network Chain/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      PC/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  4.3456 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      Argentina/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      Argentina/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  999.9999 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      Kishu 1996/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      KISHU96/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  1.2095 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      Brazil/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      Brizal/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  0.4472 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      ParaDoge/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      $PD/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  1.3721 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      Baby inu/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      BINU/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  447,213.5954 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      Phryge/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      Phryge/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  1,224,744.8713 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      DogeKingYyds/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      DogeKingYyds/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  77.4596 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      France/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      France/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  0.5291 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      SANTABSC /Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      SANTABSC/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  707.1067 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                            <li class="ant-list-item">
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="flex items-center">
                                  <div class="TokenIconGroup_root__vFcir">
                                    <div class="TokenIconGroup_icon0__1JoEk">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;/static/media/unknown-token.5e4a517e.png&quot;)" }}>
                                      </div>
                                    </div>
                                    <div class="TokenIconGroup_icon1__1eoPe">
                                      <div class="TokenIcon_root__1Ga9R TokenIcon_medium__2aNEt" style={{ backgroundImage: "url(&quot;https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png&quot;)" }}>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex-1 pl-4">
                                    <div class="PinkLockListItem_label__sjxqL">
                                      winos/Wrapped BNB</div>
                                    <div class="PinkLockListItem_symbol__1jVj2">
                                      winos/WBNB</div>
                                  </div>
                                </div>
                              </div>
                              <div class="PinkLockListItem_tvl__3xbJ6">
                                <div class="PinkLockListItem_value__2cW5b">
                                  3.8039 </div>
                              </div><Link to={LINKS.PINKLOCK_DETAIL}>View</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="has-text-centered mt-4">
                  <ul class="ant-pagination" unselectable="unselectable">
                    <li title="Previous Page" class="ant-pagination-prev ant-pagination-disabled" aria-disabled="true"><button class="ant-pagination-item-link" type="button" tabindex="-1" disabled=""><span role="img"
                      aria-label="left" class="anticon anticon-left"><svg
                        viewBox="64 64 896 896" focusable="false"
                        data-icon="left" width="1em" height="1em"
                        fill="currentColor" aria-hidden="true">
                        <path
                          d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z">
                        </path>
                      </svg></span></button></li>
                    <li title="1" class="ant-pagination-item ant-pagination-item-1 ant-pagination-item-active" tabindex="0"><a rel="nofollow">1</a></li>
                    <li title="2" class="ant-pagination-item ant-pagination-item-2" tabindex="0"><a rel="nofollow">2</a></li>
                    <li title="3" class="ant-pagination-item ant-pagination-item-3" tabindex="0"><a rel="nofollow">3</a></li>
                    <li title="4" class="ant-pagination-item ant-pagination-item-4" tabindex="0"><a rel="nofollow">4</a></li>
                    <li title="5" class="ant-pagination-item ant-pagination-item-5 ant-pagination-item-before-jump-next" tabindex="0"><a rel="nofollow">5</a></li>
                    <li title="Next 5 Pages" tabindex="0" class="ant-pagination-jump-next ant-pagination-jump-next-custom-icon">
                      <a class="ant-pagination-item-link">
                        <div class="ant-pagination-item-container"><span role="img" aria-label="double-right" class="anticon anticon-double-right ant-pagination-item-link-icon"><svg
                          viewBox="64 64 896 896" focusable="false"
                          data-icon="double-right" width="1em" height="1em"
                          fill="currentColor" aria-hidden="true">
                          <path
                            d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z">
                          </path>
                        </svg></span><span class="ant-pagination-item-ellipsis">•••</span></div>
                      </a>
                    </li>
                    <li title="1744" class="ant-pagination-item ant-pagination-item-1744" tabindex="0"><a rel="nofollow">1744</a></li>
                    <li title="Next Page" tabindex="0" class="ant-pagination-next" aria-disabled="false"><button class="ant-pagination-item-link" type="button" tabindex="-1"><span role="img" aria-label="right"
                      class="anticon anticon-right"><svg viewBox="64 64 896 896"
                        focusable="false" data-icon="right" width="1em"
                        height="1em" fill="currentColor" aria-hidden="true">
                        <path
                          d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z">
                        </path>
                      </svg></span></button></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
